<template>
  <div :class="{'error':!status.valid}" class="form__field">
    <slot name="before-input"></slot>

    <input
        :id="name"
        v-model="inputValue"
        :aria-describedby="`error__${name}`"
        :aria-invalid="!status.valid"
        :list="list"
        :min="type == 'number' ? '0' : ''"
        :name="name"
        :placeholder="placeholder"
        :type="type"
        @blur="handleBlur"
        @input="handleInput"
    />

    <label :for="name">
      {{ label ? label : name }}
      <span v-if="isRequired" class="form__indicator">*</span>
      <span v-if="tooltip" class="form__tooltip">{{ tooltip }}</span>
    </label>

    <span v-if="!status.valid" :id="`error__${name}`" class="form__error-message">
      {{ status.message }}
    </span>
  </div>
</template>

<script lang="ts" setup>
import {required, Rule} from '@/validation/rules'
import {Status, validate} from '@/validation'
import {ref, watch, computed} from "vue";

// eslint-disable-next-line
const props = defineProps<{
  name: string
  label?: string
  modelValue: string | number | undefined
  placeholder?: string
  type: string
  rules?: Rule[]
  tooltip?: string,
  list?: string,
}>();

// eslint-disable-next-line
defineExpose({
  //to call validation in parent.
  validateInput
})

const inputValue = ref<string | number | undefined>(props.modelValue === '' ? undefined : props.modelValue);
watch(props, () => inputValue.value = props.modelValue === '' ? undefined : props.modelValue)

// eslint-disable-next-line
const emit = defineEmits<{
  // states that the event has to be called 'update:modelValue'
  (event: "update:modelValue", value: string | number | undefined): void;
  (event: "validated", name: string, validationStatus: Status): void;
}>();

const status = ref<Status>({valid: true});
const isRequired = computed(() => {
  return !props.rules || props.rules.includes(required);
})

function handleInput() {
  reformatInput()
  validateInput();
  inputValue.value = inputValue.value === '' ? undefined : inputValue.value
  emit("update:modelValue", inputValue.value);
}

function handleBlur() {
  validateInput();
}

function validateInput() {
  let validationRules = props.rules ? props.rules : [required]
  status.value = validate(inputValue.value as string, validationRules)
  emit("validated", props.name, status.value);
}

function reformatInput() {
  if (props.type === "tel")
    reformatPhoneNumber()
  else if (props.type === "zip")
    reformatZipCode()
}

function reformatPhoneNumber() {
  let trimmedPhoneNumber = (inputValue.value as string).replace(/\D/g, '');
  if (trimmedPhoneNumber.length === 11) {
    let x = trimmedPhoneNumber.match(/(\d?)(\d{0,3})(\d{0,3})(\d{0,4})/);
    if (!x)
      return;
    inputValue.value = !x[2] ? x[1] : `${x[1]}-${x[2]}` + (x[3] ? `-${x[3]}` + (x[4] ? `-${x[4]}` : '') : '');
    return;
  }
  let x = trimmedPhoneNumber.match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  if (!x)
    return;
  inputValue.value = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
}

function reformatZipCode() {
  inputValue.value = (inputValue.value as string).replace(' ', '').toUpperCase()
  if (inputValue.value.length <= 9)
    return;
  inputValue.value = inputValue.value.substring(0,9);
}
</script>
